import {createModelSchema, alias, list, object, custom, serialize, deserialize, SKIP} from "serializr";
import { Cloneable } from "@/common/Cloneable";

export class ChristmasProductEntry extends Cloneable {
  constructor(product = null, amount = null) {
    super();

    this.product = product;
    this.amount = amount;
  }
}

createModelSchema(ChristmasProductEntry, {
  product: alias("product", custom(v => (v ?? null), raw => (raw ?? null))),
  amount: alias("amount", custom(v => (Number(v) || null), raw => (Number(raw) || null))),
});

export class ChristmasProducts extends Cloneable {
  constructor() {
    super();

    this._low = [];
    this._mid = [];
    this._high = [];
  }

  static schema() {
    return custom(
      v => (v ? serialize(ChristmasProducts, v) : SKIP),
      raw => deserialize(ChristmasProducts, raw),
    );
  }

  get lowProduct() {
    return this._low[0] ? this._low[0].product : null;
  }
  set lowProduct(value) {
    if (this._low[0]) {
      this._low[0].product = value;
    }
  }

  get lowAmount() {
    return this._low[0] ? this._low[0].amount : null;
  }
  set lowAmount(value) {
    if (this._low[0]) {
      this._low[0].amount = Number(value) || null;
    }
  }

  get midProduct() {
    return this._mid[0] ? this._mid[0].product : null;
  }
  set midProduct(value) {
    if (this._mid[0]) {
      this._mid[0].product = value;
    }
  }

  get midAmount() {
    return this._mid[0] ? this._mid[0].amount : null;
  }
  set midAmount(value) {
    if (this._mid[0]) {
      this._mid[0].amount = Number(value) || null;
    }
  }

  get highProduct() {
    return this._high[0] ? this._high[0].product : null;
  }
  set highProduct(value) {
    if (this._high[0]) {
      this._high[0].product = value;
    }
  }

  get highAmount() {
    return this._high[0] ? this._high[0].amount : null;
  }
  set highAmount(value) {
    if (this._high[0]) {
      this._high[0].amount = Number(value) || null;
    }
  }

  get low() {
    return this._low;
  }
  set low(arr) {
    this._low = arr || [];
  }

  get mid() {
    return this._mid;
  }
  set mid(arr) {
    this._mid = arr || [];
  }

  get high() {
    return this._high;
  }
  set high(arr) {
    this._high = arr || [];
  }

  _validateArray(arr) {
    if (!arr || !arr.length) {
      return false;
    }

    for (const entry of arr) {
      if (!entry.product) {
        return false;
      }

      const amount = entry.amount;
      if (!Number.isInteger(amount) || amount < 0) {
        return false;
      }
    }

    return true;
  }

  valid() {
    if (!this._validateArray(this._low)) {
      return false;
    }
    if (!this._validateArray(this._mid)) {
      return false;
    }
    if (!this._validateArray(this._high)) {
      return false;
    }

    return true;
  }

  clone(target = undefined) {
    return super.clone(target instanceof ChristmasProducts ? target : new ChristmasProducts());
  }
}

createModelSchema(ChristmasProducts, {
  low: alias("low", list(object(ChristmasProductEntry))),
  mid: alias("mid", list(object(ChristmasProductEntry))),
  high: alias("high", list(object(ChristmasProductEntry))),
});
